import { useDispatch, useSelector } from 'react-redux';
import { useLazyWorkplaceTermItemsQuery } from '../../../graphql/graphql';
import { useEffectAsync } from '../../../helpers';
import useLoading from '../../Base/Hooks/useLoading';
import {
	selectFieldOfCare,
	setFieldOfCareProvided,
} from '../../../store/reducers/workplaceTermItemsSlice';

export default function useWorkplaceTermItems(workplaceId: string) {
	const { isLoading, setIsLoading } = useLoading(true);
	const fieldOfCare = useSelector(selectFieldOfCare);
	const dispatch = useDispatch();
	const [getTermItems] = useLazyWorkplaceTermItemsQuery();

	const handleLoadData = async () => {
		setIsLoading(true);
		const response = await getTermItems({ id: workplaceId });

		const fieldOfCare = response?.data?.workplace?.termItems?.find(
			item => item?.term?.name === 'field_of_care',
		)?.value;

		if (fieldOfCare) {
			dispatch(setFieldOfCareProvided(fieldOfCare));
		}

		setIsLoading(false);
	};

	useEffectAsync(async () => {
		if (!fieldOfCare) await handleLoadData();
	}, []);

	return {
		isLoading,
		fieldOfCare,
	};
}
